import { IOrderElement } from './../model/types'

const calcSumSelectedElements = (array: IOrderElement[], guestID: number, prepayment: boolean): number => {
  if (array.length) {
    return array.reduce((sum: number, element: IOrderElement): number => {
      const price: number = prepayment ? element.price : element.finalPrice
      const selectedElement: number =
        element.selected && element.selected_guest_id === guestID
          ? price
          : 0
      const result: number = sum + selectedElement / 100
      return +result.toFixed(2)
    }, 0)
  }
  return 0
}

export default calcSumSelectedElements
